import { Box } from '@mui/material';
import styles from 'core/components/loader-renedernet/RenderNetLoaderStyles.module.css';
import React from 'react';

export default function RenderNetLoader({ style }) {
	return <Box className={styles.loaderRendernet} sx={style} />;
}
